import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  orderedCoreSuperBatchModulesSelector,
  setSuperBatchModules,
  useBulkReorderSuperBatchModulesMutation,
  useGetSuperBatchModulesQuery,
} from 'features/moduleManagement';
import GlobalLoader from 'components/GlobalLoader';

function SaveOrderChangesButton() {
  const dispatch = useDispatch();
  const { batch: superBatchId } = useParams();
  const { data } = useGetSuperBatchModulesQuery(superBatchId);

  const superBatchModule = useSelector(orderedCoreSuperBatchModulesSelector);
  const [
    bulkReorderSuperBatchModules,
    { isLoading: isMoving, isSuccess, error },
  ] = useBulkReorderSuperBatchModulesMutation();

  const handleOnClick = useCallback(() => {
    const reorderedSuperBatchModules = superBatchModule.map((sbm) => ({
      super_batch_module_id: sbm.id,
    }));

    bulkReorderSuperBatchModules(reorderedSuperBatchModules);
  }, [superBatchModule, bulkReorderSuperBatchModules]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Module Order changed successfully');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
      dispatch(setSuperBatchModules(data.data));
    }
  }, [data?.data, dispatch, error]);

  return (
    <>
      <GlobalLoader isVisible={isMoving} />
      <Tappable
        className="btn btn-primary"
        onClick={handleOnClick}
        disabled={isMoving}
      >
        Save Order Changes
      </Tappable>
    </>
  );
}

export default SaveOrderChangesButton;
